import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import DetailModal from '../Incharge/DetailModal';
import { update } from 'firebase/database';

const SocietyRegistrations = () => {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        const registrationsRef = ref(db, 'ekamwatapzp/SocietyRegistrations');
        const unsubData = onValue(registrationsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setRegistrations(list.reverse());
            } else {
                setRegistrations([]);
            }
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    const handleStatusUpdate = async (id, updateData) => {
        const itemRef = ref(db, `ekamwatapzp/SocietyRegistrations/${id}`);
        await update(itemRef, updateData);
    };

    const filteredData = registrations.filter(item => {
        const searchSource = `${item.societyName || ''} ${item.chairmanName || ''}`.toLowerCase();
        return searchSource.includes(searchTerm.toLowerCase());
    });

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="flex-1 p-8">
                <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">मजूर सहकारी संस्था नोंदणी यादी (Admin)</h1>
                        <p className="text-gray-500">एकूण नोंदणी: {filteredData.length}</p>
                    </div>
                </div>

                {/* Filters */}
                <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 relative">
                    <FaSearch className="absolute left-7 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input 
                        type="text" 
                        placeholder="संस्थेचे किंवा चेअरमेनचे नाव शोध..." 
                        className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* Table */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-100">
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">संस्थेचे नाव</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">चेअरमेन</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">तालुका</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">नोंदणी क्र.</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">दिनांक</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">स्थिती</th>
                                <th className="px-6 py-4 text-sm font-bold text-gray-700">कृती</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                            {filteredData.map((item) => (
                                <tr key={item.id} className="hover:bg-blue-50/50 transition-colors">
                                    <td className="px-6 py-4">
                                        <div className="font-medium text-gray-800">{item.societyName}</div>
                                        <div className="text-xs text-gray-500">{item.societyAddress}</div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="text-sm font-medium text-gray-700">{item.chairmanName}</div>
                                        <div className="text-xs text-gray-500">{item.chairmanWhatsapp}</div>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{item.taluka}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{item.registrationNo}</td>
                                    <td className="px-6 py-4 text-sm text-gray-500">
                                        {item.submittedAt ? new Date(item.submittedAt).toLocaleDateString() : '-'}
                                    </td>
                                    <td className="px-6 py-4 text-sm">
                                        <span className={`px-2 py-1 rounded text-xs font-bold border ${
                                            item.status === 'accepted' ? 'bg-green-100 text-green-700 border-green-200' : 
                                            item.status === 'rejected' ? 'bg-red-100 text-red-700 border-red-200' : 
                                            'bg-yellow-100 text-yellow-700 border-yellow-200'
                                        }`}>
                                            {item.status === 'accepted' ? 'स्वीकारले' : item.status === 'rejected' ? 'नाकारले' : 'प्रलंबित'}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4">
                                        <button 
                                            onClick={() => {
                                                setSelectedItem(item);
                                                setIsModalOpen(true);
                                            }}
                                            className="text-blue-600 hover:text-blue-800 text-sm font-bold bg-blue-50 px-3 py-1 rounded-lg transition-colors border border-blue-100"
                                        >
                                            तपशील पहा
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <DetailModal 
                    isOpen={isModalOpen} 
                    onClose={() => setIsModalOpen(false)} 
                    data={selectedItem} 
                    title="मजूर सहकारी संस्था नोंदणी"
                    onStatusUpdate={handleStatusUpdate}
                    registrations={registrations}
                    showActions={false}
                />
        </div>
    );
};

export default SocietyRegistrations;
